<div class="not-found">
    <div class="not-found__content">
        <h1>404</h1>
        <p>
            Denne side eksisterer ikke, gå tilbage til <a routerLink="/">forsiden</a>.
        </p>
    </div>
</div>